document.addEventListener("DOMContentLoaded", function () {
    
    var metaRobots = document.querySelector('meta[name="robots"][content="noindex, follow"]');

    if (metaRobots) {
        var canonicalTag = document.querySelector('link[rel="canonical"]');
        if (canonicalTag) {
            canonicalTag.parentNode.removeChild(canonicalTag);
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var searchIcon = document.querySelector('.header__icon--search');
    var closeButton = document.querySelector('.search-modal__close-button');
    var searchForm = document.querySelector('.search-modal__form');

    function handleClick() {
        if (searchForm.hasAttribute('open')) {
        } else {
        }
    }

    searchIcon.addEventListener('click', handleClick);
    closeButton.addEventListener('click', handleClick);
});

document.addEventListener('DOMContentLoaded', function () {
    // Получаем все элементы продуктов
    const productItems = document.querySelectorAll('#Slider .grid__item');
    const productArray = Array.from(productItems);

    // Проверяем, есть ли доступные продукты
    if (productArray.length === 0) {
        console.warn("Нет доступных продуктов для отображения!");
        return; // Если нет продуктов, выходим
    }

    // Перемешиваем массив с продуктами
    for (let i = productArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [productArray[i], productArray[j]] = [productArray[j], productArray[i]];
    }

    // Скрываем все элементы перед показом
    productArray.forEach(item => {
        item.style.display = "none"; // Скрываем все карточки
    });

    // Отображаем ровно 4 случайных продукта
    for (let i = 0; i < Math.min(4, productArray.length); i++) {
        productArray[i].style.display = "list-item"; // Показываем элемент
    }
});

(function () {
    var target = document.querySelector('.google_carousel');
    if (target) {
        function insertReputonWidget() {
            // Создаем скрипт элемент
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://cdn.grw.reputon.com/assets/widget.js?shop=evamats-poland.myshopify.com';
            script.defer = true;
    
            // Создаем div элемент
            var div = document.createElement('div');
            div.className = 'reputon-google-reviews-widget';
            div.setAttribute('data-content-index', '1');
            div.setAttribute('data-theme', 'dark');
            div.setAttribute('data-type', 'masonry');
            div.setAttribute('data-autoscroll', 'true');
            div.setAttribute('data-show-review-photos', 'true');
            div.setAttribute('data-write-review', 'true');
            div.setAttribute('data-show-rating', 'true');
            div.setAttribute('data-fixed-reviews-height', 'false');
    
            // Вставляем созданные элементы в элемент с классом .google_carousel
            
            target.appendChild(script);
            target.appendChild(div);
        }
    
        // Ждем полной загрузки страницы
        window.addEventListener('load', function() {
            insertReputonWidget()
        });
    }
})();



// product upsell variant buttons
(function () {
    if (document.querySelector('.product__upsell_item_variant')) {
        const buttons = document.querySelectorAll('.product__upsell_item .product__upsell_item_variant')

        buttons.forEach(el => {
            el.addEventListener('click', () => {
                const checkbox = el.closest('.product__upsell_item').querySelector('input[type="checkbox"]')
                buttons.forEach(element => {
                    element.classList.remove('active')
                })
                el.classList.add('active')
                if (el.closest('.product__info-wrapper')) {
                    checkbox.value = el.dataset.id                    
                }
            })
        })
    }
})();
// product upsell variant buttons

// video reviews
(function () {
    if (document.querySelector('.video_reviews')) {
        const videoFullScreenContainer = document.querySelector('.video_reviews__container_full');
        const closeFullscreen = videoFullScreenContainer.querySelector('.close');
        let isVisible = false; // Флаг видимости слайдера

        closeFullscreen.addEventListener('click', () => {
            videoFullScreenContainer.classList.remove('active');
            videoFullScreenContainer.querySelectorAll('video').forEach(video => {
                video.pause();
                video.currentTime = 0.1;
                video.load();
            });
            swiper.autoplay.start();
        });

        const videoPlay = (slider, full) => {
            if (!isVisible) return; // Если слайдер не виден, не воспроизводим видео

            slider.el.querySelectorAll('video').forEach(video => {
                video.pause();
            });

            const video = slider.slides[slider.activeIndex].querySelector('video');
            if (video) {
                video.currentTime = 0.2;
                video.play();
                if (!full) {
                    video.muted = true;
                }
            }
        };

        const swiper2 = new Swiper('.video_reviews__container_full', {
            loop: true,
            direction: 'vertical',
            slidesPerView: 1,
            mousewheel: {
                enabled: true,
                thresholdTime: 300,
            },
            on: {
                transitionEnd: function () {
                    if (this.el.classList.contains('active')) {
                        videoPlay(this, true);
                    }
                }
            }
        });

        const swiper = new Swiper('.video_reviews__container', {
            loop: true,
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "auto",
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 200,
                modifier: 1,
                slideShadows: true,
            },
            thumbs: {
                swiper: swiper2
            },
            navigation: {
                nextEl: document.querySelector('.video_reviews__container_wr .swiper-button-next'),
                prevEl: document.querySelector('.video_reviews__container_wr .swiper-button-prev'),
            },
            on: {
                transitionEnd: function () {
                    videoPlay(this);
                },
                tap: function () {
                    videoFullScreenContainer.classList.add('active');
                    videoPlay(swiper2, true);
                    this.autoplay.stop();
                },
                init: function () {
                    this.slides.forEach(element => {
                        element.querySelectorAll('video').forEach(video => {
                            video.currentTime = 0.2;
                        });
                    });
                }
            }
        });

        // === Intersection Observer для управления autoplay и воспроизведением видео ===
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                isVisible = entry.isIntersecting;

                if (isVisible) {
                    swiper.autoplay.start();
                    videoPlay(swiper);
                } else {
                    swiper.autoplay.stop();
                    swiper.slides.forEach(slide => {
                        slide.querySelectorAll('video').forEach(video => {
                            video.pause();
                        });
                    });
                }
            });
        }, { threshold: 0.5 });

        observer.observe(document.querySelector('.video_reviews__container'));
    }
})();
// video reviews


// toggle popup
(function () {
    if (document.querySelector('.popup_overlay')) { 
        document.addEventListener('DOMContentLoaded', function() {
            const openPopupBtn = document.querySelectorAll('.openPopup');
            const closePopupBtn = document.querySelectorAll('.popup_close_btn');
            const popupOverlay = document.querySelectorAll('.popup_overlay');
        
            openPopupBtn.forEach(btn => {
                btn.addEventListener('click', function() {
                    
                    const targetId = btn.dataset.popup
                    document.querySelector(`.popup_overlay#${targetId}`).classList.add('show');
                    document.querySelector('html').classList.add('overflow-hidden')
                });
            })
        
            closePopupBtn.forEach(el => {
                el.addEventListener('click', function() {
                    el.closest('.popup_overlay').classList.remove('show');
                    document.querySelector('html').classList.remove('overflow-hidden')
                });
            })
        
            popupOverlay.forEach(element => {
                element.addEventListener('click', function(event) {
                    if (event.target === element) {
                        popupOverlay.forEach(el => {
                            el.classList.remove('show');
                        })
                        document.querySelector('html').classList.remove('overflow-hidden')
                    }
                });
            }); 
        });
        
    }
})();
// toggle popup



// toggle class in upsell item
(function () {
    const inputs = document.querySelectorAll('.product__upsell input')
  
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        const upsellItem = input.closest('.product__upsell_item')
        if (input.checked) {
          upsellItem.classList.add('active')
        } else {
          upsellItem.classList.remove('active')
        }
      })
    })
  })();
  // toggle class in upsell item

// image comparison
(function () {
    if (document.querySelector('.comparison')) {
        let commonProgress = 0.5; // Глобальное значение прогресса для всех ползунков
        const blocks = document.querySelectorAll('.comparison__block');
    
        const isElementInViewport = (el) => {
          const rect = el.getBoundingClientRect();
          return (rect.top < window.innerHeight && rect.bottom > 0);
        };
    
        blocks.forEach(block => {
          const divisor = block.querySelector(".comparison__before"),
                slider = block.querySelector(".comparison__range");
          let animationFrame;
          let direction = 1;
          let isInteracted = false;
          let progress = 0.5;
          let lastTime = performance.now();
          const speed = 0.0004; // скорость анимации
    
          const easeInOut = (t) => {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
          };
    
          const moveDivisor = () => { 
            divisor.style.width = slider.value + "%";
          };
    
          const animateSlider = (timestamp) => {
            if (isInteracted || !isElementInViewport(block)) {
              cancelAnimationFrame(animationFrame);
              animationFrame = null;
              return;
            }
            const deltaTime = timestamp - lastTime;
            lastTime = timestamp;
            progress += (speed * deltaTime) * direction;
            if (progress >= 1) {
              progress = 1;
              direction = -1;
            } else if (progress <= 0) {
              progress = 0;
              direction = 1;
            }
            const value = 10 + easeInOut(progress) * 80;
            slider.value = value;
            moveDivisor();
            commonProgress = progress; // синхронизируем с глобальным значением
            animationFrame = requestAnimationFrame(animateSlider);
          };
    
          slider.addEventListener('input', () => {
            isInteracted = true;
            moveDivisor();
            cancelAnimationFrame(animationFrame);
          });
    
          // При отпускании мыши/касания сбрасываем progress в общее значение
          slider.addEventListener('mouseup', () => {
            isInteracted = false;
            progress = commonProgress;
            lastTime = performance.now();
            animateSlider(lastTime);
          });
    
          slider.addEventListener('touchend', () => {
            isInteracted = false;
            progress = commonProgress;
            lastTime = performance.now();
            animateSlider(lastTime);
          });
    
          slider.addEventListener('touchstart', () => {
            isInteracted = true;
            cancelAnimationFrame(animationFrame);
          });
    
          slider.addEventListener('touchmove', () => {
            isInteracted = true;
            cancelAnimationFrame(animationFrame);
          });
    
          window.addEventListener('scroll', () => {
            if (!isInteracted && isElementInViewport(block) && !animationFrame) {
              lastTime = performance.now();
              animateSlider(lastTime);
            }
          });
    
          animateSlider(lastTime);
        });

        document.querySelectorAll('.comparison__range').forEach(rangeInput => {
            rangeInput.addEventListener('touchstart', function(e) {
                e.preventDefault();
                const touch = e.targetTouches[0];
                const value = Math.round((touch.pageX - this.getBoundingClientRect().left) / this.offsetWidth * 100);
                this.value = value;
                const event = new Event('input', { bubbles: true });
                this.dispatchEvent(event);
            });

            rangeInput.addEventListener('touchmove', function(e) {
                e.preventDefault();
                const touch = e.targetTouches[0];
                const value = Math.round((touch.pageX - this.getBoundingClientRect().left) / this.offsetWidth * 100);
                this.value = value;
                const event = new Event('input', { bubbles: true });
                this.dispatchEvent(event);
            });
        });
        // скроллбар
        const container = document.querySelector(".comparison__wrapper");
        const scrollbar = document.querySelector(".comparison__scrollbar");
        const thumb = document.querySelector(".comparison__scrollbar-thumb");

        if (container && scrollbar && thumb) {
        // Обновление позиции thumb в зависимости от scrollLeft контейнера
        const updateThumb = () => {
            const scrollableWidth = container.scrollWidth - container.clientWidth;
            const scrollRatio = container.scrollLeft / scrollableWidth;
            const maxThumbMove = scrollbar.clientWidth - thumb.clientWidth;
            thumb.style.transform = `translateX(${scrollRatio * maxThumbMove}px)`;
        };

        // Перемещение контейнера по клику по скроллбару
        const moveScrollbar = (clientX) => {
            const rect = scrollbar.getBoundingClientRect();
            const offsetX = clientX - rect.left;
            const clickRatio = offsetX / scrollbar.clientWidth;
            const scrollableWidth = container.scrollWidth - container.clientWidth;
            container.scrollLeft = clickRatio * scrollableWidth;
            updateThumb();
        };

        let isDragging = false;
        let dragStartX = 0;
        let initialScrollLeft = 0;

        const startDrag = (clientX) => {
            isDragging = true;
            dragStartX = clientX;
            initialScrollLeft = container.scrollLeft;
        };

        const duringDrag = (clientX) => {
            if (!isDragging) return;
            const deltaX = clientX - dragStartX;
            const scrollbarWidth = scrollbar.clientWidth - thumb.clientWidth;
            const scrollableWidth = container.scrollWidth - container.clientWidth;
            const scrollDelta = deltaX * (scrollableWidth / scrollbarWidth);
            container.scrollLeft = initialScrollLeft + scrollDelta;
            updateThumb();
        };

        const endDrag = () => {
            isDragging = false;
        };

        // Обработчики для мыши
        thumb.addEventListener("mousedown", (e) => {
            e.stopPropagation();
            thumb.style.cursor = "grabbing";
            startDrag(e.clientX);
        });
        document.addEventListener("mousemove", (e) => {
            duringDrag(e.clientX);
        });
        document.addEventListener("mouseup", () => {
            thumb.style.cursor = "grab";
            endDrag();
        });

        // Обработчики для touch
        thumb.addEventListener("touchstart", (e) => {
            e.stopPropagation();
            const touch = e.touches[0];
            startDrag(touch.clientX);
        });
        thumb.addEventListener("touchmove", (e) => {
            const touch = e.touches[0];
            duringDrag(touch.clientX);
            e.preventDefault();
        });
        thumb.addEventListener("touchend", endDrag);

        // Обработка клика по пустому месту скроллбара (для мыши и touch)
        scrollbar.addEventListener("mousedown", (e) => {
            if (e.target !== thumb) {
            moveScrollbar(e.clientX);
            }
        });
        scrollbar.addEventListener("touchstart", (e) => {
            if (e.target !== thumb) {
            const touch = e.touches[0];
            moveScrollbar(touch.clientX);
            }
        });

        // Обновляем thumb при прокрутке контейнера
        container.addEventListener("scroll", updateThumb);
        updateThumb();
        }



        // scroll comparison on mobile
    }
})();

// image comparison